const BREAKPOINTS = {
  xs: '30em',
  sm: '48em',
  md: '64em',
  lg: '80em',
  xl: '90em',
}

export default BREAKPOINTS
